import type { Step } from "react-joyride";

export const formBuilderTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຟອມສ້າງ/ແກ້ໄຂຟອມ! ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຟອມນີ້ໃນບົດສອນສັ້ນໆນີ້. ຟອມຈະຊ່ວຍທ່ານລວບລວມຂໍ້ມູນຈາກຜູ້ໃຊ້ຕາມຄວາມຕ້ອງການ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="form-metadata"]',
    content:
      "ນີ້ແມ່ນພາກຂໍ້ມູນພື້ນຖານຂອງຟອມ. ທ່ານສາມາດກຳນົດຊື່ຟອມ, ປະເພດ, ພະແນກ, ຄຳອະທິບາຍ, ແລະຂໍ້ມູນອື່ນໆ ທີ່ຈຳເປັນສຳລັບຟອມ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="field-types-panel"]',
    content:
      "ນີ້ແມ່ນພາກປະເພດຊ່ອງຂໍ້ມູນ. ທ່ານສາມາດເລືອກປະເພດຊ່ອງຂໍ້ມູນທີ່ຕ້ອງການເຊັ່ນ: ຂໍ້ຄວາມ, ຕົວເລກ, ວັນທີ, ການເລືອກ, ແລະອື່ນໆ. ກົດປະເພດຊ່ອງຂໍ້ມູນເພື່ອເພີ່ມລົງໃນຟອມ.",
    placement: "left",
  },
  {
    target: '[data-tourid="form-editor-panel"]',
    content:
      "ນີ້ແມ່ນພາກຕົວແກ້ໄຂຟອມ. ທ່ານສາມາດລາກແລະວາງຊ່ອງຂໍ້ມູນ, ຈັດລຽງລຳດັບ, ແລະຈັດການຊ່ອງຂໍ້ມູນທັງໝົດ. ກົດຊ່ອງຂໍ້ມູນເພື່ອເລືອກແລະແກ້ໄຂ.",
    placement: "top",
  },
  {
    target: '[data-tourid="field-properties-panel"]',
    content:
      "ນີ້ແມ່ນພາກຄຸນສົມບັດຊ່ອງຂໍ້ມູນ. ເມື່ອທ່ານເລືອກຊ່ອງຂໍ້ມູນ, ທ່ານສາມາດແກ້ໄຂຄຸນສົມບັດຂອງມັນເຊັ່ນ: ຊື່, ຄຳອະທິບາຍ, ກຳນົດວ່າຈຳເປັນຕ້ອງປ້ອນ, ແລະອື່ນໆ.",
    placement: "right",
  },
  {
    target: '[data-tourid="form-actions"]',
    content:
      "ນີ້ແມ່ນປຸ່ມການກະທຳ. ທ່ານສາມາດບັນທຶກຟອມເປັນຮ່າງ (Draft), ເຜີຍແຜ່ (Publish), ຫຼືຍົກເລີກ. ຟອມທີ່ເຜີຍແຜ່ແລ້ວຈະສາມາດໃຊ້ງານໄດ້ທັນທີ.",
    placement: "top",
  },
];
